class Accordion extends HTMLElement {
  constructor() {
    super()

    this.animation = null
    this.isClosing = false
    this.isExpanding = false
    this.onClick = this.onClick.bind(this)
  }

  connectedCallback() {
    this.el = this.querySelector('details')
    this.summary = this.el.querySelector('summary')
    this.content = this.el.querySelector('.accordion__content')

    this.summary.addEventListener('click', this.onClick)
  }

  disconnectedCallback() {
    this.summary.removeEventListener('click', this.onClick)
  }

  onClick(e) {
    e.preventDefault()
    this.el.style.overflow = 'hidden'
    if (this.isClosing || !this.el.open) {
      this.openFn()
    } else if (this.isExpanding || this.el.open) {
      this.shrink()
    }
  }

  shrink() {
    this.isClosing = true

    const startHeight = `${this.el.offsetHeight}px`
    const endHeight = `${this.summary.offsetHeight}px`

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    )

    this.animation.onfinish = () => this.onAnimationFinish(false)
    this.animation.oncancel = () => (this.isClosing = false)
  }

  openFn() {
    this.el.style.height = `${this.el.offsetHeight}px`
    this.el.open = true
    window.requestAnimationFrame(() => this.expand())
  }

  expand() {
    this.isExpanding = true
    const startHeight = `${this.el.offsetHeight}px`
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    )
    this.animation.onfinish = () => this.onAnimationFinish(true)
    this.animation.oncancel = () => (this.isExpanding = false)
  }

  onAnimationFinish(open) {
    this.el.open = open
    this.animation = null
    this.isClosing = false
    this.isExpanding = false
    this.el.style.height = this.el.style.overflow = ''
  }
}

window.customElements.define('hh-accordion', Accordion)
